import { render, staticRenderFns } from "./CashBudgetV2.vue?vue&type=template&id=edf2a20e&scoped=true"
import script from "./CashBudgetV2.vue?vue&type=script&lang=js"
export * from "./CashBudgetV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf2a20e",
  null
  
)

export default component.exports